const langProductAll = async () => {
  const product = {
    id: "29",
    translations: {
      en: {
        name: "Faded into the wind",
        metadesc:
          "Faded into the Wind is an artistic piece of a horse running wild, its form being consumed by the wind, leaving only parts of its face and mane.",
        metakey: "Faded into the Wind",
        description:
          "An artistic piece that captures a horse running in the wild while it is eaten away into the wind creating a hollowing effect leaving only parts of the facial structure and mane. This piece has accurate details with a black and gold marbling effect. Made out of polyester.",
        category: ["Essence Of Form"],
        tags: ["Decorative", "Office"],
        color: "Red, Black",
        availability: "In Stock",
        attributes: {
          weight: "4.8KG",
          dimensions: "12.2cm × 51cm × 53cm",
          brand: "Mükemmel Office",
          material: "Polyester",
          color: "Red, Black",
        },
      },
      tr: {
        name: "Rüzgâra Karışan",
        metadesc:
          "Rüzgâra Karışan, vahşi doğada koşan bir atın sanatsal bir tasviridir; rüzgâr tarafından yutulmuş gibi görünür, yalnızca yüzünün ve yelesinin bazı kısımları kalır.",
        metakey: "Rüzgâra Karışan",
        description:
          "Vahşi doğada koşan bir atın rüzgârla yok oluşunu tasvir eden sanatsal bir eserdir. Atın yüz yapısının ve yelesinin bazı bölümleri kalırken, rüzgarla silinip gitmesiyle iç burkan bir etki yaratır. Siyah ve altın damar efektiyle detaylı bir şekilde işlenmiştir. Polyester malzemeden üretilmiştir.",
        category: ["Formun Özüdür"],
        tags: ["Dekoratif", "Ofis"],
        color: "Kırmızı, Siyah",
        availability: "Stokta Var",
        attributes: {
          weight: "4.8KG",
          dimensions: "12.2cm × 51cm × 53cm",
          brand: "Mükemmel Ofis",
          material: "Polyester",
          color: "Kırmızı, Siyah",
        },
      },
      ar: {
        name: "تلاشى في الريح",
        metadesc:
          "تلاشى في الريح هو عمل فني يصور حصانًا يركض في البرية، ويبدو أن الريح تلتهم شكله، تاركة فقط أجزاء من وجهه ولبدته.",
        metakey: "تلاشى في الريح",
        description:
          "قطعة فنية تجسد حصانًا يركض في البرية بينما تبتلعه الرياح تدريجيًا، مما يخلق تأثيرًا مجوفًا يترك فقط أجزاء من الوجه واللبدة. يتميز هذا العمل بتفاصيل دقيقة وتأثير رخامي باللونين الأسود والذهبي. مصنوع من مادة البوليستر.",
        category: ["جوهر الشكل"],
        tags: ["زخرفي", "مكتب"],
        color: "أحمر، أسود",
        availability: "متوفر",
        attributes: {
          weight: "4.8KG",
          dimensions: "12.2cm × 51cm × 53cm",
          brand: "مكتب موكيميل",
          material: "بوليستر",
          color: "أحمر، أسود",
        },
      },
    },
    stock_code: "BTC0001",
    price: "8.010",
    default_images: [
      "https://apimukemel.com/api/assets/BTC0001-1.webp",
      "https://apimukemel.com/api/assets/BTC0001-2.webp",
      "https://apimukemel.com/api/assets/BTC0001.webp",
    ],
    color_images: [
      {
        name: "Red",
        images: [
          "https://apimukemel.com/api/assets/BTC0001-3.webp",
          "https://apimukemel.com/api/assets/BTC0001.webp",
        ],
      },
      {
        name: "Black",
        images: [
          "https://apimukemel.com/api/assets/BTC0001-1.webp",
          "https://apimukemel.com/api/assets/BTC0001-2.webp",
          "https://apimukemel.com/api/assets/BTC0001.webp",
        ],
      },
    ],
    stock_quantity: "60",
    rating: "5.5",
  };

  return product;
};

export default langProductAll;
